import { createCompaniesByAdmin, createCompaniesDeviceByAdmin, createCompaniesDeviceContractByAdmin, createCompaniesDeviceIssueByAdmin, createCompaniesDeviceUpdateByAdmin, createCompaniesSimByAdmin, getCompaniesByAdmin, getCompaniesDeviceByAdmin, getCompaniesDeviceContractByAdmin, getCompaniesDeviceIssueByAdmin, getCompaniesDeviceRecordByAdmin, getCompaniesDeviceUpdateForIssueByAdmin, getCompaniesSimByAdmin, updateCompaniesByAdmin, updateCompaniesDeviceByAdmin, updateCompaniesDeviceContractByAdmin, updateCompaniesSimByAdmin, updateDeviceIssueStatusByAdmin } from "../../services/admin";
import { createAdminCompanyDeviceSuccess, createAdminCompanySimSuccess, createAdminCompanySuccess, getAdminCompanyDeviceContractSuccess, getAdminCompanyDeviceIssueSuccess, getAdminCompanyDeviceRecordSuccess, getAdminCompanyDeviceSuccess, getAdminCompanyDeviceUpdateForIssueSuccess, getAdminCompanySimSuccess, getAdminCompanySuccess, updateAdminCompanyDeviceSuccess, updateAdminCompanySimSuccess, updateAdminCompanySuccess } from "./reducer";

export const getAdminCompany = (isEnabled) => async dispatch => {
    try {
        var data = await getCompaniesByAdmin(isEnabled);
        let result = { ...data.data };
        dispatch(getAdminCompanySuccess(result));
    } catch (error) {
        console.log(error);
    }
};

export const updateAdminCompany = (data) => async dispatch => {
    try {
        var result = await updateCompaniesByAdmin(data);
        if (result.data.success === true) {
            dispatch(updateAdminCompanySuccess(data));
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const createAdminCompany = (data) => async dispatch => {
    try {
        var result = await createCompaniesByAdmin(data);
        if (result !== false && result.data !== null) {
            dispatch(createAdminCompanySuccess(result.data));
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const getAdminCompanySim = (isEnabled, selectedCompany) => async dispatch => {
    try {
        var data = await getCompaniesSimByAdmin(isEnabled, selectedCompany);
        let result = { ...data.data };
        dispatch(getAdminCompanySimSuccess(result));
    } catch (error) {
        console.log(error);
    }
};

export const createAdminCompanySim = (data, selectedCompany) => async dispatch => {
    try {
        var result = await createCompaniesSimByAdmin(data);
        if (result !== false && result.data !== null) {
            if (data.admin_company_id === selectedCompany) {
                dispatch(createAdminCompanySimSuccess(result.data));
            }
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const updateAdminCompanySim = (data) => async dispatch => {
    try {
        var result = await updateCompaniesSimByAdmin(data);
        if (result.data.success === true) {
            dispatch(updateAdminCompanySimSuccess(data));
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const getAdminCompanyDevice = (isEnabled, selectedCompany) => async dispatch => {
    try {
        var data = await getCompaniesDeviceByAdmin(isEnabled, selectedCompany);
        let result = { ...data.data };
        dispatch(getAdminCompanyDeviceSuccess(result));
    } catch (error) {
        console.log(error);
    }
};

export const createAdminCompanyDevice = (data, selectedCompany) => async dispatch => {
    try {
        var result = await createCompaniesDeviceByAdmin(data);
        if (result !== false && result.data !== null) {
            if (data.admin_company_id === selectedCompany) {
                dispatch(createAdminCompanyDeviceSuccess(result.data));
            }
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const updateAdminCompanyDevice = (data) => async dispatch => {
    try {
        var result = await updateCompaniesDeviceByAdmin(data);
        if (result.data.success === true) {
            dispatch(updateAdminCompanyDeviceSuccess(data));
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const getAdminCompanyDeviceRecord = (selectedDevice, selectedCompany, debouncedSearch, limit) => async dispatch => {
    try {
        var data = await getCompaniesDeviceRecordByAdmin(selectedDevice, selectedCompany, debouncedSearch, limit);
        dispatch(getAdminCompanyDeviceRecordSuccess(data));
    } catch (error) {
        console.log(error);
    }
};

export const createAdminCompanyDeviceUpdate = (data, config) => async dispatch => {
    try {
        var result = await createCompaniesDeviceUpdateByAdmin(data, config);
        if (result !== false && result.data !== null) {
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const getAdminCompanyDeviceContract = (selectedDevice, selectedCompany, debouncedSearch, limit, isActiveOnly, isLatest) => async dispatch => {
    try {
        var data = await getCompaniesDeviceContractByAdmin(selectedDevice, selectedCompany, debouncedSearch, limit, isActiveOnly, isLatest);
        dispatch(getAdminCompanyDeviceContractSuccess(data));
    } catch (error) {
        console.log(error);
    }
};

export const createAdminCompanyDeviceContract = (data) => async dispatch => {
    try {
        var result = await createCompaniesDeviceContractByAdmin(data);
        if (result !== false && result.data !== null) {            
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const updateAdminCompanyDeviceContract = (data) => async dispatch => {
    try {
        var result = await updateCompaniesDeviceContractByAdmin(data);
        if (result !== false && result.data !== null) {            
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
};

export const getAdminCompanyDeviceIssue = (selectedDevice, selectedCompany, status, debouncedSearch, limit) => async dispatch => {
    try {
        var data = await getCompaniesDeviceIssueByAdmin(selectedDevice, selectedCompany, status, debouncedSearch, limit);
        dispatch(getAdminCompanyDeviceIssueSuccess(data));
    } catch (error) {
        console.log(error);
    }
};

export const getAdminCompanyDeviceUpdateForIssue = (issueID) => async dispatch => {
    try {
        var data = await getCompaniesDeviceUpdateForIssueByAdmin(issueID);
        dispatch(getAdminCompanyDeviceUpdateForIssueSuccess({issueID:issueID, data:data}));
    } catch (error) {
        console.log(error);
    }
};

export const createAdminCompanyDeviceIssue = (data, config) => async dispatch => {
    try {
        var result = await createCompaniesDeviceIssueByAdmin(data, config);
        if (result !== false && result.data !== null) {
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
}

export const updateAdminCompanyDeviceIssueStatus = (issueID, status) => async dispatch => {
    try {
        var result = await updateDeviceIssueStatusByAdmin(issueID, status);
        if (result !== false && result.data !== null) {
            return true;
        }
        return false;
    } catch (error) {
        console.log(error);
    }
}
